// https://www.benmvp.com/blog/how-to-create-circle-svg-gradient-loading-spinner/
// https://stackoverflow.com/questions/22531861/ring-shaped-process-spinner-with-fading-gradient-effect-around-the-ring

import React from 'react';

import { cx } from '@pt-group-fe/styled-system/css';
import { LoaderVariantProps, loader } from '@pt-group-fe/styled-system/recipes';

interface LoaderProps extends React.HtmlHTMLAttributes<HTMLDivElement>, LoaderVariantProps {
  size?: number;
  thikness?: number;
  color?: string;
}

const Loader = React.forwardRef<HTMLDivElement, LoaderProps>((props, ref) => {
  const { className, variant = 'default', size = 24, thikness = 1, color, ...rest } = props;

  return (
    <div
      ref={ref}
      className={cx(loader({ variant }), className)}
      style={{
        width: size,
        padding: size / (10 * (1 / thikness)),
        background: color
      }}
      {...rest}
    />
  );
});
Loader.displayName = 'Loader';

const LOADER_VARIANTS = ['default', 'primary', 'white'];

export { Loader, LOADER_VARIANTS };
export type { LoaderProps };
